// Settings: the company's details, its products, its team and its agreement
// with us, under one heading with a tab each. The pages keep their own
// addresses (/company, /products, /team, /agreement); the setup steps open
// /company, /products and /agreement alone.

import {NavLink} from 'react-router-dom';

/** The pages that make up Settings, in the order of their tabs. */
export const SETTINGS_TABS = [
  {to: '/company', label: 'Company'},
  {to: '/products', label: 'Products'},
  {to: '/team', label: 'Team'},
  {to: '/agreement', label: 'Agreement'},
] as const;

export const SETTINGS_PATHS: readonly string[] = SETTINGS_TABS.map((tab) => tab.to);

export function SettingsHead() {
  return <>
    <header className="page-head settings-head"><div><h1>Settings</h1><p className="lead">Your company, your products, your team and your agreement with Earn.</p></div></header>
    <nav className="detail-tabs settings-tabs" aria-label="Settings">
      {SETTINGS_TABS.map((tab) => <NavLink key={tab.to} to={tab.to} className={({isActive}) => (isActive ? 'active' : '')}>{tab.label}</NavLink>)}
    </nav>
  </>;
}
